jQuery(document).ready(function () {
	'use strict';

    //Adjust sticky main menu height
    const stickyMenuHeight = function () {
        $('.jean-coutu-menu').css('height', ($('.mm__container').innerHeight()));
    }
    stickyMenuHeight();
    $(window).on('resize', globalFunction.throttle(stickyMenuHeight, 500));

	setTimeout(function(){
		$('[data-module~="stickyState"]').stickyState();
	}, 200);

    $('.search__overlay .close--btn').on('click', function() {
        $('.search__overlay').hide();
        $('.search__overlay-container #header--search--input').val('');
    });

    $('[data-input-clear=""]').click( function () {
        manageEraseButton($(this));
    });
});

function manageSearchButtonWithEraseButton($inputSearch) {
    var $parentForm = $inputSearch.closest('form, .form');
    var $buttonClose = $parentForm.find('.input-close');
    if ($buttonClose.length) {
        if ($inputSearch.val() !== '') {
            $buttonClose.removeClass('field_is_empty');
        } else {
            $buttonClose.addClass('field_is_empty');
        }
    }
}

function manageEraseButton($eraseButton) {
    var parentForm = $eraseButton.closest('form, .form');
    $(parentForm).find('input[type=search]').val('');
    $(parentForm).find('.input-close').addClass('field_is_empty');
    $(parentForm).find('input[type=search]').focus();
}

// Must be on all pages
$('input[type=search]').keyup( function () {
    manageSearchButtonWithEraseButton($(this));
});

redirectIfConflict = function (jqXHR, reloadOnForbidden) {
    console.error('Ajax error: ' + jqXHR.status);
    if (jqXHR.status === HTTP_CONFLICT_STATUS) {
        const newLocation = jqXHR.getResponseHeader("Location");

        // avoid an infinite redirection loop if an ajax error occurs in the internal server error page and the browser is already there
        if ((typeof inInternalServerErrorPage !== 'undefined' && inInternalServerErrorPage) && (newLocation === '/erreur/500' || newLocation === '/en/error/500')) {
            return false;
        }

        if (isInWebview() && (newLocation === '/erreur/401' || newLocation === '/en/error/401')) {
            // For AJAX calls in web view mode, page 401 might not function correctly if the browser disallows the HTTP Header Referer.
            // As a workaround, the message will be sent here instead of redirecting to page 401
            sendSessionExpirationToDevice(window.location.href);
        } else {
            window.location = newLocation;
        }

        return true;
    } else if ((jqXHR.status === HTTP_FORBIDDEN_STATUS && (reloadOnForbidden || reloadOnForbidden === undefined)) || jqXHR.status === HTTP_STATUS_RELOAD) {
        window.location.reload(true);
        return true;
    }
    return false;
};

const globalFunction = function () {
    const throttle = (func, delay) => {
        // Previously called time of the function
        let prev = 0;
        return (...args) => {
            let now = new Date().getTime();
            if (now - prev > delay) {
                prev = now;
                return func(...args);
            }
        }
    };

    const debounce = (func, timeout = 300) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    };

    return {
        throttle:throttle,
        debounce: debounce
    }
}();
